import React from 'react';
import { useIdleTimer } from "react-idle-timer";
import Countdown from "react-countdown";
import {
  MSG_LOADING_GENERICO,
  TIEMPO_MAXIMO_INACTIVIDAD,
  TIEMPO_PARA_EJECUTAR_ACCION,
} from "../../app/infrastructure/appConstants";
import { validarFechaExpiracionRefrehTokenProrroga } from "../../app/config/auth/credentialConfiguration";
import {
  logout,
  refreshToken,
  setShowDialogUserIddle,
} from "../../app/store/actions/authActions";
import { Button, Header, Modal } from "semantic-ui-react";
import { connect } from "react-redux";

//Labels Locales
const LABEL_MODAL_USUARIO_IDLE_TITLE = "Aviso";

const getMessageAviso = (seconds) =>
  `Tu sesión finalizará en: ${seconds} segundos.`;

//Redux - Actions
const actions = {
  logout,
  refreshToken,
  setShowDialogUserIddle,
};

const mapState = (state) => ({
  currentUser: state.auth.currentUser,
  loadingRefreshToken: state.auth.loadingRefreshToken,
  showDialogUserIddle: state.auth.showDialogUserIddle,
});

const IdleMonitor = ({
  currentUser,
  loadingRefreshToken,
  showDialogUserIddle,
  logout,
  refreshToken,
  setShowDialogUserIddle,
}) => {
  const handleOnIdle = (event) => {
    if (window.Culqi) {
      //Cerrando Culqi en caso haya sido cargado
      window.Culqi.close();
    }
    setShowDialogUserIddle(true);
    //console.log("last active", getLastActiveTime());
  };

  const handleOnActive = (event) => {
    //console.log("user is active", event);
    // console.log("time remaining", getRemainingTime());
  };

  const handleOnAction = (e) => {
    //console.log("user did something", e);
    // setShowDialogUserIddle(false);
  };

  useIdleTimer({
    timeout: TIEMPO_MAXIMO_INACTIVIDAD,
    onIdle: handleOnIdle,
    onActive: handleOnActive,
    onAction: handleOnAction,
    debounce: 500,
  });

  const rendererRefreshToken = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      return (
        <>
          <div>Se cierra sesion por inactividad</div>
        </>
      );
    } else {
      return (
        <Modal open={true} dimmer="inverted" size="mini">
          <Header icon size="small" color="blue">
            {LABEL_MODAL_USUARIO_IDLE_TITLE}
          </Header>
          <Modal.Content>
            <Header as="h5" color="grey" textAlign="center">
              {loadingRefreshToken === true
                ? MSG_LOADING_GENERICO
                : getMessageAviso(seconds)}
            </Header>
          </Modal.Content>
          <Modal.Actions>
            <Button
              content="Continuar"
              color="yellow"
              onClick={async () => {
                await refreshToken();
                setShowDialogUserIddle(false);
              }}
              loading={loadingRefreshToken}
            />
            <Button
              content="Salir"
              color="blue"
              onClick={() => {
                logout();
              }}
            />
          </Modal.Actions>
        </Modal>
      );
    }
  };

  const rendererSesionExpirada = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      return (
        <>
          <div>Tu sesion ha finalizado</div>
        </>
      );
    } else {
      return (
        <Modal open={true} dimmer="inverted" size="mini">
          <Header icon size="small" color="blue">
            {LABEL_MODAL_USUARIO_IDLE_TITLE}
          </Header>
          <Modal.Content>
            <Header as="h5" color="grey" textAlign="center">
              {getMessageAviso(seconds)}
            </Header>
          </Modal.Content>
          <Modal.Actions>
            <Button
              content="Salir"
              color="blue"
              onClick={() => {
                logout();
              }}
            />
          </Modal.Actions>
        </Modal>
      );
    }
  };

  return (
    <>
      {showDialogUserIddle &&
        (validarFechaExpiracionRefrehTokenProrroga() === true ? (
          <Countdown
            date={Date.now() + TIEMPO_PARA_EJECUTAR_ACCION}
            renderer={rendererRefreshToken}
            onComplete={() => {
              logout();
            }}
          />
        ) : (
          <>
            <Countdown
              date={Date.now() + TIEMPO_PARA_EJECUTAR_ACCION}
              renderer={rendererSesionExpirada}
              onComplete={() => {
                logout();
              }}
            />
          </>
        ))}
    </>
  );
};

export default connect(mapState, actions)(IdleMonitor);
